// @ts-check
import { ccextApiClient, ccextUnauthApiClient } from '../../utils/RequestClient';

/**
 * @typedef {import('@action-types/ccApps').CcAppsSearchPayload} CcAppsSearchPayload
 * @typedef {import('@action-types/ccApps').CcAppsSearchResponse} CcAppsSearchResponse
 *
 * @param {object} params
 * @param {CcAppsSearchPayload} [params.payload]
 * @param {AbortSignal} [params.signal]
 * @param {string} [params.viewerCountry] - Can be used to override server geolocation for special use cases. Takes ISO2 country code.
 */
const searchCcApps = async ({ signal, payload, viewerCountry }) => {
  let apiClient = ccextApiClient;
  const headers = new Headers({
    accept: 'application/vnd.adobe-ccextension.extension-list-v4+json',
    'Content-Type': 'application/vnd.adobe-ccextension.extension-filter-v3+json',
  });

  if (viewerCountry) {
    headers.set('x-viewer-country', viewerCountry);
    apiClient = ccextUnauthApiClient;
  }

  /** @type {Awaited<ReturnType<typeof ccextApiClient.fetch<CcAppsSearchResponse, unknown>>>} */
  const data = await apiClient.fetch({
    endpoint: `/extensions`,
    requestOptions: {
      signal,
      headers,
      method: 'POST',
      body: JSON.stringify(payload),
    },
  });

  return data;
};

export default searchCcApps;
